import React, { useEffect } from "react";
import PdfPageFrame from "../../components/PdfPageFrame";

function MentionsLegalesScreen() {
  useEffect(() => {
    document.body.style.overflowX = 'hidden';
    return () => { document.body.style.overflowX = ''; };
  }, []);



  return (
    <>
      <div style={{ background: 'var(--vert-clair-nuance-5)', minHeight: '100vh' }}>
      <section className="section-3" style={{background: "none", paddingBottom: "64px", paddingTop: "2em"}}>
          <div className="page containerAccueil">
            <PdfPageFrame>
              <div id="pdfContent" style={{
                  position: 'relative',
                  textAlign: 'justify',
                  textJustify: "inter-word",
                  width: 'auto',
                  fontSize: "14px",
                  lineHeight: "1.5714285714285714",
                  fontFamily: "-apple-system,BlinkMacSystemFont,'Segoe UI',Roboto,'Helvetica Neue',Arial,'Noto Sans',sans-serif,'Apple Color Emoji','Segoe UI Emoji','Segoe UI Symbol','Noto Color Emoji'",
                  listStyle: "none",
                  padding: "20mm 20mm"
                }}
              >
                <h1>Mentions Légales</h1>

                <h2>1. Éditeur du site</h2>
                <p>
                    Le site internet <a href="https://www.ravail.fr">www.ravail.fr</a> (ci-après le « Site ») est édité par :
                </p>
                <div>
                    <span className="puce-item"><span style={{marginRight: "0.3em"}}>•</span><strong>Raison sociale :</strong> RAVAIL SAS</span>
                    <span className="puce-item"><span style={{marginRight: "0.3em"}}>•</span><strong>Siège social :</strong> 19B rue du Gaudron, 95270 Viarmes, France</span>
                    <span className="puce-item"><span style={{marginRight: "0.3em"}}>•</span><strong>Capital social :</strong> 10 000 euros</span>
                    <span className="puce-item"><span style={{marginRight: "0.3em"}}>•</span><strong>RCS :</strong> Pontoise B 953 985 074</span>
                    <span className="puce-item"><span style={{marginRight: "0.3em"}}>•</span><strong>Numéro de TVA intracommunautaire :</strong> FR13953985074</span>
                    <span className="puce-item"><span style={{marginRight: "0.3em"}}>•</span><strong>Téléphone :</strong> +33 1 84 80 80 41</span>
                    <span className="puce-item"><span style={{marginRight: "0.3em"}}>•</span><strong>Email :</strong> contact@ravail.fr</span>
                    <span className="puce-item"><span style={{marginRight: "0.3em"}}>•</span><strong>Directeur de la publication :</strong> Dr Quentin Nocture</span>
                </div>

                <h2>2. Hébergement</h2>
                <p>
                    Le Site est hébergé en France par :
                </p>
                <div>
                    <span className="puce-item"><span style={{marginRight: "0.3em"}}>•</span><strong>Raison sociale :</strong> OVH SAS</span>
                    <span className="puce-item"><span style={{marginRight: "0.3em"}}>•</span><strong>Adresse :</strong> 2 rue Kellermann - 59100 Roubaix - France</span>
                    <span className="puce-item"><span style={{marginRight: "0.3em"}}>•</span><strong>Site web :</strong> <a href="https://www.ovhcloud.com" target="_blank" rel="noreferrer">www.ovhcloud.com</a></span>
                    <span className="puce-item"><span style={{marginRight: "0.3em"}}>•</span><strong>Certification HDS :</strong> OVH est certifié Hébergeur de Données de Santé (HDS). <a href="https://www.lne.fr/recherche-certificats/data_certificats/37387-5.pdf" target="_blank" rel="noreferrer">Voir le certificat</a></span>
                    <span className="puce-item"><span style={{marginRight: "0.3em"}}>•</span><strong>Certification ISO 27001 : </strong> OVH est certifié ISO 27001. <a href="https://www.lne.fr/recherche-certificats/data_certificats/37383-6.pdf" target="_blank" rel="noreferrer">Voir le certificat</a></span>
                </div>

                <h2>3. Propriété intellectuelle</h2>
                <p>
                    L’ensemble des contenus (textes, images, vidéos, logos, graphismes, icônes, etc.) présents sur le Site sont la propriété exclusive de RAVAIL ou de tiers ayant autorisé leur utilisation.
                </p>
                <p>
                    Toute reproduction, représentation, modification, publication, adaptation de tout ou partie des éléments du Site, quel que soit le moyen ou le procédé utilisé, est interdite, sauf autorisation écrite préalable de RAVAIL.
                </p>

                <h2>4. Limitation de responsabilité</h2>
                <p>
                    RAVAIL s’efforce de fournir des informations aussi précises et sourcées que possible. Toutefois, elle ne pourra être tenue responsable si certaines informations sont erronées ou incomplètes. Si vous avez un doute ou une question médicale, veuillez contacter votre médecin du travail.
                </p>

                <h2>5. Liens hypertextes</h2>
                <p>
                    Le Site peut contenir des liens hypertextes vers d’autres sites internet. RAVAIL n’a aucun contrôle sur le contenu de ces sites et décline toute responsabilité quant aux informations, produits ou services qui y sont proposés. 
                </p>

                <h2>6. Cookies</h2>
                <p>
                    Le Site n'utilise pas de cookie pour collecter des informations sur l'utilisateur ni pour suivre sa navigation. Seul les cookies strictement nécessaires au bon fonctionnement du Site sont utilisés, notamment pour la gestion des sessions d'authentification.
                </p>

                <h2>7. Droit applicable</h2>
                <p>
                    Les présentes mentions légales sont régies par le droit français. Tout litige relatif à l’utilisation du Site sera soumis à la compétence des tribunaux français.
                </p>

                <footer>
                    <p><em>Dernière mise à jour : 23/11/2023</em></p>
                </footer>
              </div>
            </PdfPageFrame>
          </div>
      </section>
      </div>
    </>
  );
}

export default MentionsLegalesScreen;
